import type { Course } from "../model/types";

const COURSES: Course[] = [
  {
    id: "cbt-basics",
    title: "Основы КПТ",
    subtitle: "Когнитивно-поведенческая терапия",
    difficulty: 2,
    duration: "6 недель",
    modules: 12,
    tags: ["Тревога", "Депрессия", "Практика"],
    progress: 34,
    favorite: true,
    description:
      "Как мысли создают эмоции и поведение. Конкретные техники работы с деструктивными паттернами.",
    goal: "Научиться распознавать и изменять деструктивные мыслительные паттерны, управлять эмоциями через когнитивное переструктурирование.",
    result:
      "Вы овладеете базовыми техниками КПТ, сможете самостоятельно работать с тревогой и депрессивными состояниями, применять методы поведенческой активации.",
    modulesList: [
      "Введение в когнитивную модель",
      "ABC-схема: события, мысли, эмоции",
      "Автоматические мысли и их фиксация",
      "Когнитивные искажения",
      "Сократический диалог",
      "Проверка реальностью",
      "Поведенческая активация",
      "Градуированные задания",
      "Работа с избеганием",
      "Экспозиция in vivo",
      "Профилактика рецидивов",
      "Интеграция и план на будущее",
    ],
  },
  {
    id: "trauma-recovery",
    title: "Работа с травмой",
    subtitle: "От выживания к жизни",
    difficulty: 4,
    duration: "8 недель",
    modules: 16,
    tags: ["ПТСР", "Травма", "Телесность"],
    progress: 0,
    favorite: false,
    description:
      "Травма живёт в теле. Методы освобождения от застывших реакций — EMDR, соматика, нейробиология.",
    goal: "Понять нейробиологию травмы, освоить методы работы с телесными проявлениями ПТСР, восстановить чувство безопасности.",
    result:
      "Снижение симптомов ПТСР, восстановление способности к саморегуляции, интеграция травматического опыта через соматические и когнитивные техники.",
    modulesList: [
      "Нейробиология травмы",
      "Окно толерантности",
      "Телесные маркеры безопасности",
      "Ресурсные состояния",
      "Заземление и ориентация",
      "Работа с диссоциацией",
      "Введение в EMDR",
      "Двусторонняя стимуляция",
      "Обработка травматических воспоминаний",
      "Соматическое переживание",
      "Работа с застывшими реакциями",
      "Восстановление границ",
      "Нарративная интеграция",
      "Посттравматический рост",
      "Работа с близкими",
      "Жизнь после травмы",
    ],
  },
  {
    id: "mindfulness",
    title: "Практика осознанности",
    subtitle: "MBSR",
    difficulty: 1,
    duration: "8 недель",
    modules: 8,
    tags: ["Стресс", "Тревога", "Медитация"],
    progress: 87,
    favorite: true,
    description:
      "Программа снижения стресса через осознанность. Без эзотерики — чистая нейронаука.",
    goal: "Развить навык осознанного присутствия, снизить реактивность на стресс, научиться наблюдать опыт без автоматических реакций.",
    result:
      "Устойчивое снижение уровня стресса, улучшение эмоциональной регуляции, развитие метакогнитивной осознанности, стабильная практика медитации.",
    modulesList: [
      "Автопилот и осознанность",
      "Восприятие и реальность",
      "Пребывание в теле",
      "Стресс-реакция vs стресс-отклик",
      "Автоматичность и выбор",
      "Мысли — это не факты",
      "Забота о себе",
      "Интеграция в жизнь",
    ],
  },
  {
    id: "emotion-regulation",
    title: "Регуляция эмоций",
    subtitle: "DBT навыки",
    difficulty: 3,
    duration: "10 недель",
    modules: 20,
    tags: ["ПРЛ", "Эмоции", "Навыки"],
    progress: 12,
    favorite: false,
    description:
      "Диалектическая поведенческая терапия. Как управлять интенсивными эмоциями без разрушения.",
    goal: "Овладеть четырьмя модулями DBT: осознанность, стрессоустойчивость, эмоциональная регуляция, межличностная эффективность.",
    result:
      "Способность переносить дистресс без деструктивного поведения, навыки управления интенсивными эмоциями, улучшение отношений.",
    modulesList: [
      "Диалектическое мышление",
      "Осознанность: «Что» навыки",
      "Осознанность: «Как» навыки",
      "Модель эмоций",
      "Функции эмоций",
      "Снижение уязвимости (PLEASE)",
      "Накопление позитивного опыта",
      "Opposite Action",
      "Самоуспокоение через 5 чувств",
      "IMPROVE момента",
      "TIP навыки",
      "Radical Acceptance",
      "DEAR MAN",
      "GIVE навыки",
      "FAST навыки",
      "Валидация",
      "Walking the Middle Path",
      "Цепной анализ",
      "Управление кризисами",
      "Построение жизни, ради которой стоит жить",
    ],
  },
  {
    id: "sleep-restoration",
    title: "Восстановление сна",
    subtitle: "CBT-I",
    difficulty: 2,
    duration: "4 недели",
    modules: 8,
    tags: ["Бессонница", "Сон", "КПТ"],
    progress: 0,
    favorite: true,
    description:
      "Когнитивно-поведенческая терапия бессонницы. Эффективнее снотворных, без побочек.",
    goal: "Восстановить здоровый паттерн сна через изменение убеждений и поведения, связанного со сном.",
    result:
      "Засыпание менее чем за 20 минут, консолидированный сон, отказ от снотворных, устойчивый циркадный ритм.",
    modulesList: [
      "Физиология сна",
      "Дневник сна и оценка",
      "Гигиена сна",
      "Контроль стимулов",
      "Ограничение сна",
      "Когнитивная реструктуризация",
      "Релаксационные техники",
      "Профилактика и поддержание",
    ],
  },
  {
    id: "relationship-patterns",
    title: "Паттерны отношений",
    subtitle: "Схема-терапия",
    difficulty: 4,
    duration: "12 недель",
    modules: 24,
    tags: ["Отношения", "Привязанность", "Схемы"],
    progress: 56,
    favorite: false,
    description:
      "Глубинные схемы, которые саботируют близость. Работа с детскими ранаи через схема-терапию.",
    goal: "Выявить ранние дезадаптивные схемы, понять их происхождение, развить здоровые способы удовлетворения потребностей.",
    result:
      "Осознание паттернов выбора партнёров, изменение деструктивных копинг-стратегий, развитие secure attachment.",
    modulesList: [
      "Введение в схема-терапию",
      "18 ранних дезадаптивных схем",
      "Схемы отвержения и разъединения",
      "Схемы нарушенной автономии",
      "Схемы нарушенных границ",
      "Схемы направленности на других",
      "Схемы гиперконтроля",
      "Базовые эмоциональные потребности",
      "Режимы схем",
      "Уязвимый ребёнок",
      "Разгневанный ребёнок",
      "Импульсивный ребёнок",
      "Счастливый ребёнок",
      "Дисфункциональные родители",
      "Дисфункциональные копинги",
      "Здоровый взрослый",
      "Ограниченное перевоспитание",
      "Эмпатическая конфронтация",
      "Работа с imagery",
      "Письма родителям",
      "Поведенческие паттерн-брейки",
      "Терапевтические отношения",
      "Романтические отношения",
      "Интеграция и завершение",
    ],
  },
  {
    id: "anxiety-mastery",
    title: "Работа с тревогой",
    subtitle: "Экспозиция и принятие",
    difficulty: 3,
    duration: "8 недель",
    modules: 16,
    tags: ["Тревога", "Паника", "ОКР"],
    progress: 0,
    favorite: false,
    description:
      "Не борьба с тревогой, а проход сквозь неё. Экспозиция, ACT, конкретные протоколы.",
    goal: "Освоить экспозиционные техники, научиться принимать тревогу без избегания, снизить функциональные нарушения.",
    result:
      "Расширение поведенческого репертуара, снижение избегания, способность действовать при наличии тревоги.",
    modulesList: [
      "Нейробиология тревоги",
      "Цикл тревоги и избегания",
      "Иерархия страхов",
      "Градуированная экспозиция",
      "Интероцептивная экспозиция",
      "Экспозиция с предотвращением реакции (для ОКР)",
      "Когнитивная дефузия",
      "Принятие и готовность",
      "Ценности vs цели",
      "Committed Action",
      "Работа с паническими атаками",
      "Социальная тревога",
      "Генерализованное тревожное расстройство",
      "Обсессивно-компульсивное расстройство",
      "Работа с рецидивами",
      "Жизнь с тревогой",
    ],
  },
  {
    id: "self-compassion",
    title: "Самосострадание",
    subtitle: "Против самокритики",
    difficulty: 1,
    duration: "6 недель",
    modules: 6,
    tags: ["Самооценка", "Перфекционизм", "Практика"],
    progress: 100,
    favorite: true,
    description:
      "Как перестать быть своим худшим врагом. Практические техники самосострадания.",
    goal: "Развить способность относиться к себе с добротой, принимать несовершенство, признавать общность человеческого опыта.",
    result:
      "Снижение самокритики и стыда, повышение эмоциональной устойчивости, развитие внутренней поддерживающей позиции.",
    modulesList: [
      "Три компонента самосострадания",
      "Распознавание внутреннего критика",
      "Практика доброты к себе",
      "Общность человеческого опыта",
      "Осознанность vs избыточная идентификация",
      "Интеграция в повседневную жизнь",
    ],
  },
];

export const courseRepo = {
  list: async (): Promise<Course[]> => COURSES,
  byId: async (id: string): Promise<Course | null> =>
    COURSES.find((c) => c.id === id) ?? null,
  byTag: async (tag: string): Promise<Course[]> =>
    COURSES.filter((c) => c.tags.includes(tag)),
  favorites: async (): Promise<Course[]> =>
    COURSES.filter((c) => c.favorite),
};
